routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.account', {
      url: __env.routes.account,
      template: `<account sh-ctrl="shCtrl"></account>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/account/account.config.js